import React, { useEffect } from "react"
import { Grid, Box, Typography } from "@material-ui/core"
import { useDispatch, useSelector } from "react-redux"
import { RootState } from "typesafe-actions"
import { getRestaurantPaymentCardsAsyncThunk } from "../accountDetailsSlice"
import QmoLoader from "../../Common/QmoLoader"
import RestaurantPaymentCard from "./RestaurantPaymentCard"


export default function RestaurantPaymentCards() {
    const dispatch = useDispatch()
    const _accountDetails = useSelector((state: RootState) => state.accountDetailsRdc)

    useEffect(() => {
        dispatch(getRestaurantPaymentCardsAsyncThunk())
    }, [])

    return (
        <Grid container>
            {(_accountDetails.getPaymentCardsBusy) ?
                <QmoLoader />
                :
                <>
                    {(_accountDetails.paymentCards && _accountDetails.paymentCards.length > 0) ?
                        <>
                            {
                                _accountDetails.paymentCards?.map((c, i) => {
                                    return <Grid key={i} item><Box p={1}><RestaurantPaymentCard card={c} /></Box></Grid>
                                })
                            }
                        </>
                        :
                        <Box p={1}><Typography variant="h4">No payment sources defined yet. You can add them during payment process.</Typography></Box>
                    }

                </>
            }
        </Grid >
    )
}